import angular from 'angular';
import api from './builder/api.html';
import conditional from './builder/conditional.html';
import data from './builder/data.html';
import events from './builder/events.html';
import layout from './builder/layout.html';
import validate from './builder/validate.html';

angular.module('app')
	.run(/* @ngInject */ (
		/** @type {import('angular').ITemplateCacheService} */ $templateCache,
	) => {
		$templateCache.put('kform/components/common/api.html', api);
		$templateCache.put('kform/components/common/conditional.html', conditional);
		$templateCache.put('kform/components/common/data.html', data);
		$templateCache.put('kform/components/common/events.html', events);
		$templateCache.put('kform/components/common/layout.html', layout);
		$templateCache.put('kform/components/common/validate.html', validate);
	});
